import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { AppleStyleSpinner } from "./AppleStyleSpinner";

const CreateMembershipModal = ({
  open,
  onClose,
  newMembershipName,
  setNewMembershipName,
  onCreateMembership,
  loading = false,
}) => {
  const [validityYears, setValidityYears] = useState(1); // Default to 1 year

  const handleClose = () => {
    if (loading) return;
    setNewMembershipName("");
    setValidityYears(1); // Reset to default
    onClose();
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && newMembershipName.trim() && !loading) {
      onCreateMembership(validityYears);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      TransitionProps={{
        timeout: 400,
      }}
      PaperProps={{
        sx: {
          animation: open ? "slideUp 0.3s ease-out" : "none",
          "@keyframes slideUp": {
            from: {
              opacity: 0,
              transform: "translateY(20px)",
            },
            to: {
              opacity: 1,
              transform: "translateY(0)",
            },
          },
        },
      }}
    >
      <DialogTitle sx={{ fontSize: "15px", fontWeight: 600 }}>
        Create New Membership
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Membership Name"
          fullWidth
          value={newMembershipName}
          onChange={(e) => setNewMembershipName(e.target.value)}
          placeholder="e.g., Gold Membership, Premium Plan"
          onKeyPress={handleKeyPress}
          disabled={loading}
          sx={{ mb: 2 }}
        />

        <FormControl fullWidth margin="dense">
          <InputLabel id="validity-years-label">Years of Membership</InputLabel>
          <Select
            labelId="validity-years-label"
            id="validity-years-select"
            value={validityYears}
            label="Years of Membership"
            onChange={(e) => setValidityYears(e.target.value)}
            disabled={loading}
          >
            {[...Array(10)].map((_, index) => {
              const year = index + 1;
              return (
                <MenuItem key={year} value={year}>
                  {year} {year === 1 ? "year" : "years"}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={() => onCreateMembership(validityYears)}
          variant="contained"
          disabled={!newMembershipName.trim() || loading}
          sx={{
            minWidth: "140px",
            position: "relative",
          }}
        >
          {loading ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
              }}
            >
              <AppleStyleSpinner />
              <span>Creating...</span>
            </Box>
          ) : (
            "Create Membership"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateMembershipModal;
